export default __webpack_public_path__ + "static/media/sh_12.634bf17f.png";